import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/aplicativo-segmentos',
  name: 'aplicativo-segmentos',
  component: Index,
  children: [
    { path: 'listar', name: 'aplicativo-segmentos-listar', component: Listar },
    { path: 'novo', name: 'aplicativo-segmentos-novo', component: Novo },
    { path: ':id', name: 'aplicativo-segmentos-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'aplicativo-segmentos-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/aplicativo-segmentos/routes.js